import PopoverTip from '@/creditflowresearch/ui/common/components/molecules/PopoverTip';

interface IProps {
  title?: React.ReactNode,
  description?: React.ReactNode,
  onClose: () => void,
}

const UserPreferenceTip = ({
  title = 'Customize Your Experience',
  description = 'Select your default credit product and region in your profile menu. This will determine the page you land on at login. You can update this preference at any time.',
  onClose,
}: IProps) => (
  <PopoverTip
    dataTest="userPreferenceTip"
    closeDataTest="UserPreferenceTipCloseButton"
    title={ title }
    onClose={ onClose }
  >
    { description }
  </PopoverTip>
);

export default UserPreferenceTip;
